<template>
  <div class="home-container">
    <Navbar scrollNum="100" />
    <!-- PAGE WRAP -->
    <div id="page-wrap">
      <!-- BANNER SLIDER -->
      <section class="section-swiper">
        <swiperCom />
      </section>

      <!-- END / BANNER SLIDER -->

      <!-- ACCOMD ODATIONS -->
      <!-- 房间展示模块 -->
      <section class="section-accomd awe-parallax bg-14">
        <hotelInfoCom />
      </section>
      <!-- END / ACCOMD ODATIONS -->

      <section class="section-accomd awe-parallax bg-14">
        <miniSwiperCom />
      </section>


      <!-- ACCOMD ODATIONS -->
      <!-- 饮食娱乐模块 -->
      <!-- <section class="section-accomd awe-parallax bg-14">
        <playEatInfoCom />
      </section> -->
      <!-- END / ACCOMD ODATIONS -->

      <!-- ACCOMD ODATIONS -->
      <!-- 艺术空间模块 -->
      <section class="art-space">
        <h3>
          <el-divider content-position="left">艺 术 空 间</el-divider>
        </h3>
        <artSpaceCom />
      </section>

      <!-- END / ACCOMD ODATIONS -->


      <section class="section-home-about bg-white">
        <h3>
          <el-divider content-position="left">影 像 纪 事</el-divider>
        </h3>
        <MediaSpaceCom></MediaSpaceCom>

      </section>


      <!-- ABOUT -->
      <!-- 关于我们 -->
      <section class="section-home-about bg-white">
        <h3>
          <el-divider content-position="right">关 于 我 们</el-divider>
        </h3>

        <div class="container" style="max-width: 1300px">
          <div class="home-about">
            <div class="row">

              <div class="col-md-6">
                <el-carousel direction="vertical" trigger="click">
                  <el-carousel-item v-for="(item, index) in carouselSlides" :key="index">
                    <div class="img" style="height: 100%; width: 100%">
                      <a href=""><img :src="item.imageUrl" alt="" style="height: 100%" /></a>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
              <div class="col-md-6">
                <div class="text">
                  <!-- <h2 class="heading">关于我们</h2> -->
                  <!-- <span class="box-border"></span> -->
                  <p style="font-size: 17px">
                    在横琴粤澳深度合作区的核心腹地，一场旅居空间的革新正悄然启幕。当澳门全力打造“演艺之都”“体育之城”，横琴伍号酒店应势而生，打破传统酒店边界，成为粤港澳大湾区首间“赛演友好型”专业精品酒店。
                  </p>

                  <a href="https://mp.weixin.qq.com/s/tLE7Dd5o0UrFUIb3YJHwmQ" target="_blank"
                    class="awe-btn awe-btn-default">了解更多</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- END / ABOUT -->

      <footerCom />
    </div>

    <!-- END / PAGE WRAP -->
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import swiperCom from "@/components/swiperCom.vue";
import hotelInfoCom from "@/components/hotelInfoCom.vue";
// import playEatInfoCom from "@/components/playEatInfoCom.vue";
import artSpaceCom from "@/components/artSpaceCom.vue";
import Navbar from "@/components/navBar.vue";
import footerCom from "@/components/footerCom.vue";
import { memberApi } from "@/utils/memberApi.js"
import miniSwiperCom from "@/components/miniSwiperCom.vue"
import MediaSpaceCom from "@/components/mediaSpaceCom.vue"
// import { GetRoomPriceList, GetRoomTypeList } from "@/utils/roomRequest";

export default {
  name: "HomeView",
  data() {
    return {
      carouselSlides: [
        {
          imageUrl: "https://www.hqhotel5.com/img/MiniImg/roomImg/base01.jpg",
          title: "First slide label",
          description:
            "Some representative placeholder content for the first slide.",
        },
        {
          imageUrl: "https://www.hqhotel5.com/img/MiniImg/roomImg/base02.jpg",
          title: "Second slide label",
          description:
            "Some representative placeholder content for the second slide.",
        },
        {
          imageUrl: "https://www.hqhotel5.com/img/MiniImg/roomImg/base03.jpg",
          title: "Third slide label",
          description:
            "Some representative placeholder content for the third slide.",
        },
      ],
    };
  },
  mounted() {
    memberApi.getMemberInfo().then(res => {
      console.log('res =>', res);
      if (res.errCode != '000') {
        this.$store.commit('setLogin', false)
      }
    })
    // this.getRoomPriceList();
    // this.getRoomType();

  },
  methods: {},
  components: {
    // HelloWorld
    swiperCom,
    hotelInfoCom,
    // playEatInfoCom,
    artSpaceCom,
    footerCom,
    Navbar,
    miniSwiperCom,
    MediaSpaceCom
  },
};
</script>

<style lang="scss">
@import "../assets/css/style.css";

.art-space {
  width: 80%;
  margin: auto;

  h3 {
    width: 100%;
    text-align: start;
    font-size: 30px;

    .el-divider__text {
      font-size: 25px;
      font-weight: bold;
      background-color: transparent;
    }
  }
}

.el-carousel__item {
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;

  p,
  h3 {
    width: 95%;
  }

  p {
    text-align: justify;
  }

  .img-box {
    position: relative;

    img {
      height: 100%;
    }

    .btn {
      position: absolute;
      right: 1rem;
      bottom: 2rem;
    }
  }
}

.el-carousel__item h3 {
  color: #ae9281;
  font-size: 14px;
  line-height: 50px;
  margin: 0;
  font-size: 20px;
  font-weight: bold;
}

.el-carousel__item:nth-child(2n) {
  background-color: white;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: white;
}

.section-home-about {
  padding-bottom: 100px;
  border-radius: 20px 20px 0 0;

  img {
    border-radius: 10px;
  }

  h3 {
    width: 80%;
    margin: auto;
    text-align: start;
    font-size: 30px;

    .el-divider__text {
      font-size: 25px;
      font-weight: bold;
    }
  }
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

/* 媒体查询：小屏幕设备（如手机） */
@media (max-width: 768px) {
  .el-carousel__container {
    height: 25vh;
  }
}
</style>
